import { makeStyles, tokens, typographyStyles } from '@fluentui/react-components';

export const getCompanyNameOptionStyles = makeStyles({
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: '16px',
    height: '16px',
    marginRight: tokens.spacingXS,
  },
  name: {
    ...typographyStyles.body1Strong,
  },
  industryAndSize: {
    ...typographyStyles.body1,
    color: tokens.colorNeutralForeground4,
  },
});
